import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ThemeContext from '../../theme/ThemeContext'; 
import styles from './Button.module.css';

const Button = ({ children, transparent, secondary, onClick, className, style, disabled, small }) => {
  const theme = useContext(ThemeContext);

  // Kreiraj kombinaciju CSS klasa
  let buttonClasses = [styles.button];
  
  if (transparent) {
    buttonClasses.push(styles.buttonTransparent);
  }
  
  if (secondary) {
    buttonClasses.push(styles.buttonSecondary);
  }
  
  if (small) {
    buttonClasses.push(styles.smallbtn);
  }
  
  if (className) {
    buttonClasses.push(className);
  }

  return (
    <button
      className={buttonClasses.join(' ')}
      onClick={onClick}
      disabled={disabled}
      style={{
        fontFamily: theme.fonts.primary,
        ...style
      }}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  transparent: PropTypes.bool,
  secondary: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  small: PropTypes.bool,
};

Button.defaultProps = {
  transparent: false,
  secondary: false,
  onClick: () => {},
  className: '',
  style: {},
  disabled: false,
  small: false,
};

export default Button;
